import React from 'react';

import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
} from 'features/menu/pages/recent-items-page/recent-order-card-list/empty-state/styled';

import { FriesSvg as ErrorEmptyStateImage } from 'components/svgs/fries';
import { t } from 'state/intl/translations';

interface IErrorStateProps {
  onRefresh?: () => void;
}

const ErrorState: React.FC<React.PropsWithChildren<IErrorStateProps>> = ({ onRefresh }) => {
  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <ErrorEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('recentItemsFailed')}</HeaderText>
      {!!onRefresh && (
        <StyledActionButtonLink onPress={onRefresh}>{t('refresh')}</StyledActionButtonLink>
      )}
    </EmptyStateWrapper>
  );
};

export default ErrorState;
